import React, { useEffect } from "react";
import './styles.css';

const sleep = (s) => new Promise(resolve => setTimeout(resolve, (s * 1000) | 0));

function MessagePopUp({ title, text, color, onClose }) {
  useEffect(() => {
    const timeout = setTimeout(async () => {
      await sleep(0.1);
      onClose(); 
    }, 10000);

    return () => clearTimeout(timeout);
  }, [text, onClose]);

  return (
    <div className="messageP">
      <button onClick={onClose}>X</button>
      <h2 style={{ color }}>{title}</h2>
      <p>{text}</p>
    </div>
  );
}

export default React.memo(MessagePopUp);
